import * as types from '../mutation-types';
import { includeAddressWithCustomers } from '@/configs/global.config'
export default {
    namespaced: true,
    state: {
        accounts: [],
        customers: [],
        staff: []
    },

    actions: {
        fetchAll({ commit }, { regionIds, name, type, nonDeleted, IncludeContactInfo, includeAddresses, perPage, page }) {
            var urlSearchParams = new URLSearchParams();
            var params = { name, type, nonDeleted, IncludeContactInfo, includeAddresses, perPage, page };
            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) {
                    urlSearchParams.append(param, params[param]);
                } 
            })
            regionIds.forEach(regionId => {
                urlSearchParams.append("regionIds", regionId);
            })
            return window.axios.get('/account', {
                params: urlSearchParams 
            }).then((response) => {
                commit(types.STORE_ACCOUNTS, response.data)
                return {
                    data: response.data,
                    total: parseInt(response.headers['x-pagination-total-count'])
                }
            })
        },

        fetchAllBrief({ commit }, { type, regionIds, nonDeleted, includeAddress, entityTypeId }) {
            var urlSearchParams = new URLSearchParams();
            var params = { type, entityTypeId, nonDeleted };
            Object.keys(params).forEach(param => {
                if (params[param] !== null && params[param] !== undefined) {
                    urlSearchParams.append(param, params[param]);
                } 
            })

            urlSearchParams.append("includeAddress", includeAddressWithCustomers)
            return window.axios('account/briefWithEntityTypeId', { params: urlSearchParams, once: true }).then(({ data }) => {
                if (type === 0 && (regionIds.length === 0 || regionIds === null) && includeAddress && !entityTypeId) {
                    commit(types.STORE_ACCOUNT_STAFF, data)
                } else if (type === 1 && (regionIds.length === 0 || regionIds === null) && includeAddress && !entityTypeId) {
                    console.log('store')
                    commit(types.STORE_ACCOUNT_CUSTOMER, data)
                }
                return data
            })
        },

        create({ commit }, { data }) {
            return window.axios.post('/account', data).then(({ data }) => {
                return data
            })
        },

        update({ commit }, { id, data }) {
            return window.axios.put(`/account/${id}`, data).then(({ data }) => {
                return data
            })
        },

        delete({ commit }, { id }) {
            return window.axios.delete(`/account/${id}`)
        },

        reset({ commit }) {
			commit(types.RESET);
		}
    },
    mutations: {
        [types.RESET_STATE] () {

        },
        
        [types.STORE_ACCOUNTS] (state, accounts) {
            state.accounts = accounts
        },

        [types.STORE_ACCOUNT_CUSTOMER](state, customers) {
            state.customers = customers
        },

        [types.STORE_ACCOUNT_STAFF](state, staff) {
            state.staff = staff
        },

        [types.RESET](state) {
            state.accounts = []
            state.customers = []
            state.staff = []
		}
    },

    getters: {
        getAccountById: state => id => state.accounts.find(c => c.accountId === id)
    }
}